module.exports = __webpack_public_path__ + "static/img/service-07.c4f7c099.png";